<mat-sidenav-container class="sidenav-container">

  <!-- Sidebar -->
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">

    <div class="sidebar-content p-16">
      <div class="sidebar-brand d-flex align-items-center justify-content-start mb-3">
        <div class="sidebar-logo d-flex align-items-center justify-content-center">
          <!-- <img src="https://files.sokrates.co.id/pri/image/tenant/logo/54fd6c95-5a92-4387-8989-e7a7e5cfba9b.png" alt="" style="max-width: 50px; height: 50px;"> <span class="ms-16 fw-medium fs-24 fw-bold">Sokrates</span> -->
          <img [src]="webSettings.logo_url" alt="" class="sidebar-logo-image">
        </div>
        <div class="sidebar-title fw-bold white-space-nowrap ms-4" style="font-size: 18px;">
          School Program
        </div>
        <div>

        </div>
        <!-- <div class="text-center fw-medium fs-16 fw-bold row">
          {{ webSettings.school_name || 'Sokrates System' }}
        </div> -->
      </div>

      <!-- <div class="pt-8">
        <ul>
          <li class="list-group mb-2" *ngFor="let sidenav of sidebarMenu">
              <a matRipple [matRippleColor]="'#f7f8f443'"
                 *ngIf="sidenav.task ? auth.current().permissions[sidenav.task] : true"
                 [routerLink]="sidenav.link"
                 class="sidebar-menu w-100 d-flex align-items-center"
                 (click)="triggerAcademicYearChange()"
                 [routerLinkActive]="routerActive">

                  <i-feather name="{{ sidenav.icon }}" class="feather-base me-12"></i-feather>
                  <span class="ps-4m text-decoration-none">{{ sidenav.menu }}</span>
              </a>
          </li>
        </ul>
      </div> -->

      <div class="pt-8">
        <ul>
          <li class="list-group mb-2" *ngFor="let sidenav of sidebarMenu">
            <!-- Parent menu without children -->
            <ng-container *ngIf="!sidenav.children">
              <a matRipple [matRippleColor]="'#f7f8f443'"
                 *ngIf="sidenav.task ? auth.current()?.permissions[sidenav.task] : true"
                 [routerLink]="sidenav.link"
                 class="sidebar-menu w-100 d-flex align-items-center"
                 [routerLinkActive]="routerActive">
                <i-feather name="{{ sidenav.icon }}" class="feather-base me-12"></i-feather>
                <span class="ps-4m text-decoration-none">{{ sidenav.menu }}</span>
              </a>
            </ng-container>
      
            <!-- Parent menu with children -->
            <ng-container *ngIf="sidenav.children">
              <div class="sidebar-menu w-100 d-flex align-items-center" (click)="sidenav.expanded = !sidenav.expanded">
                <i-feather name="{{ sidenav.icon }}" class="feather-base me-12"></i-feather>
                <span class="ps-4m text-decoration-none">{{ sidenav.menu }}</span>
                <i-feather name="chevron-down" class="ms-auto" [class.rotate]="sidenav.expanded"></i-feather>
              </div>
              <ul class="nested-menu-list w-full" *ngIf="sidenav.expanded">
                <li *ngFor="let child of sidenav.children" class="children-li">
                  <a matRipple [matRippleColor]="'#f7f8f443'"
                    *ngIf="child.task ? auth.current().permissions[child.task] : true"
                    [routerLink]="child.link"
                    class="sidebar-menu w-100 d-flex align-items-center"
                    [routerLinkActive]="routerActive">
                    <i-feather name="{{ child.icon }}" class="feather-base me-12"></i-feather>
                    <span class="ps-4m text-decoration-none">{{ child.menu }}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
        </ul>
      </div>

<!--      <div class="m-8 pt-4">-->
<!--        <div class="buy-flexy ps-24 pe-24 mt-48 mb-48">-->
<!--          <div class="text-center">-->
<!--            <img src="assets/images/sidebar-buynow-bg.svg" class="img-fluid" alt="">-->
<!--            <div class="pt-24 pb-24 mt-8">-->
<!--              <p class="fw-bold fs-18 mb-16 pb-8">Get This for Free</p>-->
<!--              <ul>-->
<!--                <li class="mb-8">-->
<!--                  <a href="https://www.wrappixel.com/templates/flexy-angular-admin-free/" mat-flat-button color="primary" class="fw-light w-100 fs-14">Download Free</a>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <a href="https://www.wrappixel.com/templates/flexy-material-angular-admin/?ref=33" mat-flat-button color="accent" class="w-100 fw-light fs-14">Check Pro</a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>

  </mat-sidenav>

  <mat-sidenav-content>

    <!-- Header -->
    <app-header
        [breadcrumbItems]="breadcrumbItems"
        [currentUser]="currentUser"
        [canSwitchAccount]="canSwitchAccount"
        [isSwitchedAccount]="isSwitchedAccount"
        [isSwitchingAccount]="isSwitchingAccount"
        [isRestoringAccount]="isRestoringAccount"
        [realAdminName]="realAdminName"
        (toggleSidebar)="drawer.toggle()"
        (openAccount)="onOpenAccount()"
        (switchAccount)="onSwitchAccount()"
        (restoreAccount)="onRestoreAccount()"
        (logOut)="onLogOut()">
    </app-header>

    <!-- Content -->
    <div class="body-wrapper">
      <div class="page-wrapper" *ngIf="applyRouterOutlet">
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- <p class="text-center pb-24 fs-16">Copyright © Sokrates System - BINUS Creates, All Rights Reserved.</p> -->

  </mat-sidenav-content>

</mat-sidenav-container>


<!-- Search Box -->
<div *ngIf="search" class="search-section d-flex align-items-center">
  <mat-form-field class="w-100" color="primary" >
    <mat-label class="fs-16">Search Here</mat-label>
    <input matInput>
  </mat-form-field>
  <button mat-icon-button (click)="search=!search">
    <i-feather name="x-circle" class="mt-n3 text-light-muted feather-base text-dark"></i-feather>
  </button>
</div>
